/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { style as s } from '../style';
import LayerContent from '../layer/LayerContent';

const TabContentArea = ({ 
    activeTab,
    fileInputRef,
    isUploadModalOpen,
    isDragActive,
    openUploadModal,
    closeUploadModal,
    handleFileUpload,
    handleClick,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    handleDownload1,
    handleDownload2,
    ...restOfLayerProps
}) => {

    return (
        <div css={s.tabContentArea}>
            {activeTab === 'layer' && (
                <LayerContent
                    // 레이어 Props 및 나머지 Props 전달
                    {...restOfLayerProps}
                    
                    // 파일/모달 Props 명시적 전달
                    fileInputRef={fileInputRef}
                    isUploadModalOpen={isUploadModalOpen}
                    isDragActive={isDragActive}
                    openUploadModal={openUploadModal}
                    closeUploadModal={closeUploadModal}
                    handleFileUpload={handleFileUpload}
                    handleClick={handleClick}
                    handleDrop={handleDrop}
                    handleDragOver={handleDragOver}
                    handleDragLeave={handleDragLeave}
                    handleDownload1={handleDownload1}
                    handleDownload2={handleDownload2}
                />
            )}
            {activeTab !== 'layer' && (
                <div css={s.noDataMessage}>기능 구현 예정입니다.</div>
            )}
        </div>
    );
};

export default TabContentArea;